import { types } from '../../constants/ActionTypes'
import { deepCopy } from '../../lib'

const initialState = {
  records: [],
}

const history = (state = initialState, action) => {
  var newRecords
  switch (action.type) {
    case types.history.RESPONSE_SELECT_EVENT_HISTORY:
      if (action.response.result === false && action.response.records.length === 0) {
        return state
      }
      newRecords = deepCopy(state.records)
      action.response.records.forEach(record => {
        newRecords = newRecords.filter(newRecord => newRecord.id !== record.id)
        newRecords.push({ historyType: 'event', ...record })
      })
      return {
        ...state,
        records: newRecords,
      }
    default:
      return state
  }
}

export default history


// WEBPACK FOOTER //
// ./src/reducers/Common/history.js